export const VERIFIED_TOOLTIP =
  'SchooLinks has verified that this credential was issued to the student by a recognized credential provider.';
export const UNVERIFIED_TOOLTIP =
  'SchooLinks was unable to verify that this credential was issued to the student by a recognized credential provider.';
export const DOES_NOT_EXPIRE_TEXT = 'Does not expire';
